// useBillboardAnalytics customHook

import { Movie } from "@multicines/types";
import { useEffect } from "react";

import useAnalytics from "hooks/analytics/useAnalytics";

const useBillboardAnalytics = (props: UseBillboardAnalyticsProps) => {
  const { isSuccessShowBillboard, isFetchedShowBillboard } = props;
  const { movies: moviesRaw } = props;
  const { uid } = props;
  const analyticsHook = useAnalytics({
    isSnackWorkflow: false
  });

  const { logViewMovieCatalogue, canBeSendAnalytics } = analyticsHook;
  const { logViewContentMovieCatalogue } = analyticsHook;
  const { logInitTalkshop } = analyticsHook;

  useEffect(() => {
    if (!canBeSendAnalytics) return;

    logInitTalkshop({
      screen: "billboard",
      level: undefined
    });
  }, [canBeSendAnalytics, logInitTalkshop, uid]);

  useEffect(() => {
    if (!canBeSendAnalytics) return;
    if (!isFetchedShowBillboard) return;

    logViewMovieCatalogue();
  }, [canBeSendAnalytics, isFetchedShowBillboard, logViewMovieCatalogue]);

  useEffect(() => {
    if (!canBeSendAnalytics) return;
    if (!isSuccessShowBillboard) return;
    if (!moviesRaw?.length) return;

    const movies = moviesRaw.map(movie => {
      const { title, externalId } = movie;
      return { name: title, id: externalId, quantity: 1 };
    });

    const moviesFormattedEvent = movies.map(movie => {
      const { id, quantity } = movie;
      return { id, quantity };
    });

    logViewContentMovieCatalogue({
      content_ids: JSON.stringify(movies.map(movie => movie.id)),
      contents: JSON.stringify(moviesFormattedEvent)
    });
  }, [
    canBeSendAnalytics,
    isSuccessShowBillboard,
    logViewContentMovieCatalogue,
    moviesRaw
  ]);
};

export default useBillboardAnalytics;

interface UseBillboardAnalyticsProps {
  uid: string | undefined;
  isSuccessShowBillboard: boolean;
  isFetchedShowBillboard: boolean;
  movies: Movie[] | undefined;
}
